import _ from 'lodash';
import moment from 'moment';

export default {
  computed: {
    availableAssessmentItems() {
      return _.map(this.assessmentItems, a => ({
        metric: a.metric.metricTab.name,
        name: a.metric.name,
        totalRequests: a.totalRequests,
        totalResponses: a.totalResponses,
        totalSuccess: a.totalSuccess,
        when: a.metric.when,
        who: a.metric.who,
        progress: Math.round(a.totalResponses / a.totalRequests * 100, 0),
      }));
    },
    assessmentItemsByMetric() {
      return _(this.availableAssessmentItems)
        .groupBy(x => x.metric)
        .map((value, key) => ({
          metric: key,
          totalRequests: _.sumBy(value, 'totalRequests'),
          totalResponses: _.sumBy(value, 'totalResponses'),
          totalSuccess: _.sumBy(value, 'totalSuccess'),
        })).value();
    },
    clientAssessment() {
      return _.chain(this.assessments)
        .filter(a => a.clientId === this.clientId)
        .map((a) => {
          // eslint-disable-next-line no-param-reassign
          a.text = `${a.name} (${moment(a.created).fromNow()})`;
          return a;
        })
        .sortBy(a => a.created)
        .reverse()
        .value();
    },
    metricAmbassador() {
      return this.reportAssessmentItems.find(m => m.metric === 'Ambassador Program Metrics');
    },
    metricBehaviour() {
      return this.reportAssessmentItems.find(m => m.metric === 'Impact Metrics – Behaviors');
    },
    metricStrategic() {
      return this.reportAssessmentItems.find(m => m.metric === 'Impact Metrics – Strategic');
    },
    metricCompliance() {
      return this.reportAssessmentItems.find(m => m.metric === 'Compliance Metrics');
    },
    metricTotal() {
      if (this.availableAssessmentItems?.length === 0) {
        return undefined;
      }
      return {
        totalRequests: _.sumBy(this.availableAssessmentItems, 'totalRequests'),
        totalResponses: _.sumBy(this.availableAssessmentItems, 'totalResponses'),
        totalSuccess: _.sumBy(this.availableAssessmentItems, 'totalSuccess'),
      };
    },
  },
};
